<template>
  <section id="create-new-account-section" class="section-scc-portal container">
    <div class="bottom-banner">
      <p class="p-section" v-html="headerMessage"/>
    </div>
    <form
        id="form-create-new-account-portal-scc"
        :model="newAccountData"
        @submit.prevent="checkDonorInfo"
    >
      <div class="row container-item-form">
        <div class="container-input-form container-input-form-left col-sm">
          <password-input
              error-message="The password you entered contains space(s), please remove it if it was added by mistake."
              message="Required field."
              label = "Create Password"
              :outside-error-action = "objInvalid.password"
              name = "newAccountCreatePassword"
              @change_newAccountCreatePassword = "function(val){newAccountData.password = val}"
              @focus_newAccountCreatePassword = "function(val){objInvalid.password = val}"
          />
        </div>
        <div class="container-input-form container-input-form-right col-sm">
          <password-input
              error-message="The password you entered contains space(s), please remove it if it was added by mistake."
              message="Required field."
              label = "Confirm Password"
              :outside-error-action = "objInvalid.passwordConfirm"
              name = "newAccountConfirmPassword"
              @change_newAccountConfirmPassword = "function(val){newAccountData.passwordConfirm = val}"
              @focus_newAccountConfirmPassword = "function(val){objInvalid.passwordConfirm = val}"

          />
        </div>
      </div>
      <div class="row container-item-form">
        <div class="container-input-form container-input-form-left col-sm">
          <label class="label-form-css" for="first-name-my-profile">First Name</label>
          <input
              type="text"
              class="form-control input-form-css"
              id="first-name-my-profile"
              :class="{'invalid-item':objInvalid.firstName}"
              aria-describedby="firstNameHelp"
              v-on:focus="firstNameFocusIn"
              v-model.trim="newAccountData.firstName"
          >
          <small id="firstNameHelp" class="form-text text-muted">Required field.</small>
        </div>
        <div class="container-input-form container-input-form-right col-sm">
          <label class="label-form-css" for="last-name-my-profile">Last Name</label>
          <input
              type="text"
              class="form-control input-form-css"
              :class="{'invalid-item':objInvalid.lastName}"
              id="last-name-my-profile"
              aria-describedby="lastNameHelp"
              v-on:focus="lastNameFocusIn"
              v-model.trim="newAccountData.lastName"
          >
          <small id="lastNameHelp" class="form-text text-muted">Required field.</small>
        </div>
      </div>
      <div class="row container-item-form">
        <div class="container-input-form container-input-form-left col-sm">
          <label class="label-form-css" for="login-donor-portal-email">Email</label>
          <input
              type="email"
              class="form-control input-form-css"
              id="login-donor-portal-email"
              :class="{'invalid-item':objInvalid.email}"
              aria-describedby="emailHelp"
              v-on:focus="emailFocusIn"
              v-model.trim="newAccountData.email"
          >
          <small id="emailHelp" class="form-text text-muted">Required field.</small>
        </div>
        <date-piker
          :dateDatePiker="newAccountData.dob"
          nameDatePiker="Date of Birth"
          :class="{'invalid-item':objInvalid.dob}"
          :error-event="objInvalid.dob"
          v-on:datePicker="changeDob"
        />
      </div>
      <div class="row container-item-form">
        <div class="container-input-form container-input-form-left col-sm">
          <label class="label-form-css" for="last-name-my-profile">Cell #</label>
          <input
              v-if="maskCell!==''"
              type="tel"
              class="form-control input-form-css"
              v-bind:class="{'invalid-item':objInvalid.homePhone}"
              id="phone-mobile"
              aria-describedby="phone_mobile-help"
              :placeholder="placeholderCell"
              v-mask="maskCell"
              v-on:focus="mobilePhoneFocusIn"
              v-model.trim="newAccountData.phoneMobile"
          >
          <input
              v-else
              type="tel"
              class="form-control input-form-css"
              v-bind:class="{'invalid-item':objInvalid.homePhone}"
              id="phone-mobile"
              aria-describedby="phone_mobile-help"
              v-on:focus="mobilePhoneFocusIn"
              v-model.trim="newAccountData.phoneMobile"
          >
          <small id="phoneMobileHelp" class="form-text text-muted">Required field.</small>
        </div>
        <div class="container-input-form container-input-form-right col-sm">
          <label class="label-form-css" for="last-name-my-profile">{{findDonorBy.label}}</label>
          <input
            type="text"
            class="form-control input-form-css"
            v-bind:class="{'invalid-item':objInvalid.idDonationOrDonor}"
            id="id-donation-or-donor"
            aria-describedby="idDonationHelp"
            v-on:focus="idDonationOrDonorFocusIn"
            v-model.trim="newAccountData.idDonationOrDonor"
          >
          <small id="idDonationHelp" class="form-text text-muted">Required field.</small>
        </div>
      </div>
      <div id="smsContainer" v-show="smsHide">
      <div class="container-radio-sms-opt" style="display: flex;">
        <p>{{ messageOptIn }}</p>
      </div>
      <div class="container-radio-sms-opt" style="display: flex;">
        <div class="form-check" style="margin-right: 15px;">
          <input
              class="form-check-input"
              v-bind:class="{ 'error-radio': objInvalid.smsOptedOut }"
              type="radio"
              name="smsOptedOut"
              id="sms-opted-in-input"
              v-model="smsOptedOut.include"
              value = "false"
              v-on:focus="optedOutFocusIn"
              v-on:change="optedOutChange"
          >
          <label
              class="form-check-label"
              v-bind:class="{ 'error-radio': objInvalid.smsOptedOut }"
              for="sms-opted-in-input"
          >
            Opt In
          </label>
        </div>
        <div class="form-check">
          <input
              class="form-check-input"
              v-bind:class="{ 'error-radio': objInvalid.smsOptedOut}"
              type="radio"
              name="smsOptedOut"
              id="sms-opted-out-input"
              v-model="smsOptedOut.include"
              value = "true"
              v-on:focus="optedOutFocusIn"
              v-on:change="optedOutChange"
          >
          <label
              class="form-check-label"
              v-bind:class="{ 'error-radio': objInvalid.smsOptedOut }"
              for="sms-opted-out-input"
          >
            Opt Out
          </label>
        </div>
      </div>
      <small id="id DonationHelp" class="form-text text-muted">Required field.</small>
      </div>
      <div style="display:block; margin-right: auto; margin-left: auto">
        <div class="row container-item-form" style="text-align: center">
          <button
              type="submit"
              class="button-section btn"
              value="Log In"
          >
            CONFIRM
            <font-awesome-icon :icon="['fas', 'chevron-right']" />
          </button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>


import moment from 'moment-timezone';
import xlooLib from "../../../../librarys/xlooLib";
import { mapState } from 'vuex';
import datePiker from "../../../elements/datePiker";
import md5 from 'md5';
import PasswordInput from "../../../elements/passwordInput";
import {mask} from  'vue-the-mask';
export default {
  name: "createNewAccount",
  components: { datePiker, PasswordInput },
  data(){
    return {
      smsOptedOut: {
        banner: '',
        include: '',
        OptOutState: false,
        OptInState: true,
      },
      newAccountData:{
        email: '',
        password: '',
        passwordConfirm: '',
        firstName: '',
        lastName: '',
        dob: '',
        idDonationOrDonor: '',
        phoneMobile: '',
        homePhone: '',
        idDonor: '',
        smsOptedOut: null,
      },
      objInvalid: {
        email: false,
        password: false,
        passwordConfirm: false,
        firstName: false,
        lastName: false,
        dob: false,
        donationOrDonor: false,
        phoneMobile: false,
        homePhone: false,
        smsOptedOut: false,
      },
      messageDonorNotFound: '',
      smsHide: true,
      headerMessage: '',
      placeholderCell: '',
      maskCell: '',
    }
  },
  directives: {
    mask
  },
  computed: {
    ...mapState({
      requiredArr: state => state.settingsAndCustomize.crmSettings.required,
      messageOptIn: state => state.settingsAndCustomize.siteCustomizationData.profilePage.messageOptIn,
      findDonorBy:  state => state.settingsAndCustomize.donorPortalSettings.findDonor,
      smsEnable: state => state.settingsAndCustomize.crmSettings.sendSms.smsEnable,
      messCreateNewAccountState: state => state.settingsAndCustomize.siteCustomizationData.messages.createNewAccount,
      messUniqueEmailValidation: state => state.settingsAndCustomize.siteCustomizationData.messages.uniqueEmailValidation,
      headerPhoneState: state => state.settingsAndCustomize.siteCustomizationData.headerFooter.phone,
      phoneFormat: state => state.settingsAndCustomize.crmSettings.phoneFormat,
      phoneFormats: state => state.settingsAndCustomize.crmSettings.phoneFormats,
    }),
  },
  beforeMount() {
    this.hideSmsSend();
  },
  mounted() {
    let sccThis = this
    this.$root.$on('datePickerDateofBirth', date => sccThis.changeDob(date))
    this.$root.$on('focusInputDatePicker', () => sccThis.dobFocusIn())

    this.messageDonorNotFound = this.$store.getters["settingsAndCustomize/messages"]('notFoundDonor')

    let messCreateNewAccount = this.messCreateNewAccountState
    const headerPhone = this.headerPhoneState
    const scheduleLink = '<span class="span-link" ><a class="hover-item-a links-section" href="' + this.$store.getters["settingsAndCustomize/configurationSite"].urlSite + 'donate-blood">here </a></span>'
    messCreateNewAccount = messCreateNewAccount.replace(/\$Schedule/g, scheduleLink)
    messCreateNewAccount = messCreateNewAccount.replace(/\$Phone/g, headerPhone)
    messCreateNewAccount = messCreateNewAccount.replace(/\$VerificationDonor/g, this.findDonorBy.label)
    this.headerMessage = messCreateNewAccount

    if(this.phoneFormat !== '' && Object.keys(this.phoneFormats).length > 0){
      this.placeholderCell = xlooLib.createMaskForPhone(this.phoneFormats[this.phoneFormat], this.phoneFormat, 'x' )
      this.maskCell = xlooLib.createMaskForPhone(this.phoneFormats[this.phoneFormat], this.phoneFormat, '#' )
    }
  },
  methods: {
    changeNewAccountCreatePassword(val){
      this.newAccountData.password = val
    },
    hideSmsSend(){
      if(!this.smsEnable){
        this.smsOptedOut.include = true;
        this.smsHide = false;
      }
    },
    // eslint-disable-next-line no-unused-vars
    changeCreatePassword(val){

    },
    async checkDonorInfo(){
      if (this.smsOptedOut.include === ''){
        this.callDangerMessageBox('SMS Opted In or Opted Out - Required field.')
        return false
      } else {
        this.newAccountData.smsOptedOut = this.smsOptedOut.include==='false'?false:true;
      }
      if (this.newAccountData.password === ''){
        this.callDangerMessageBox('Password - Required field.')
        this.objInvalid.password = true;
        return false
      }
      if (this.newAccountData.passwordConfirm === ''){
        this.callDangerMessageBox('Confirm Password - Required field.')
        this.objInvalid.passwordConfirm = true;
        return false
      }
      if (this.newAccountData.first_name === ''){
        this.callDangerMessageBox('First Name - Required field - Required field.')
        this.objInvalid.firstName = true;
        return false
      }
      if (this.newAccountData.last_name === ''){
        this.callDangerMessageBox('Last Name - Required field.',)
        this.objInvalid.lastName = true;
        return false
      }
      if (this.newAccountData.email === ''){
        this.callDangerMessageBox('Email - Required field.')
        this.objInvalid.email = true;
        return false
      }
      if (this.newAccountData.dob === ''){
        this.callDangerMessageBox('Date of Birth - Required field.')
        this.objInvalid.dob = true;
        return false
      }
      if (this.newAccountData.idDonationOrDonor === ''){
        this.callDangerMessageBox('Previous Donation # or Donor Id# - Required field.')
        this.objInvalid.donationOrDonor = true;
        return false
      }
      if (this.newAccountData.phoneMobile === ''){
        this.callDangerMessageBox('Cell - Required field.')
        this.objInvalid.homePhone = true;
        return false
      }
      if (xlooLib.phoneCleaner(this.newAccountData.phoneMobile).length < 10 && this.requiredArr.phoneMobile){
        this.callDangerMessageBox('Cell - Phone number must be at least 10 numbers.')
        this.objInvalid.homePhone = true;
        return false
      }

      let re = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$")
      if (!re.test(this.newAccountData.password)){
        this.callDangerMessageBox(
            'Password must contain:\n' +
            '- at least 8 characters;\n' +
            '- at least one letter and one number;\n' +
            '- at least one uppercase and one lowercase letter;',
        )
        this.objInvalid.password = true;
        this.objInvalid.passwordConfirm = true;
        return false
      }
      if (this.newAccountData.password!=this.newAccountData.passwordConfirm){
        this.callDangerMessageBox('Password does not match confirm password.')
        this.objInvalid.password = true;
        this.objInvalid.passwordConfirm = true;
        return false
      }
      let ageNewDonor = this.newAccountData.dob;

      if(Number(moment().diff(ageNewDonor, 'years')) < 16) {
        this.callDangerMessageBox('You are ' + Number(moment().diff(ageNewDonor, 'years')) + ' years old. You are under 16 years old.')
        this.objInvalid.dob = true;
        return false
      }
      if(Number(moment().diff(ageNewDonor, 'years')) > 100) {
        this.callDangerMessageBox('You are ' + Number(moment().diff(ageNewDonor, 'years')) + ' years old. You are older than 100 years old.')
        return false;
      }
      this.newAccountData.smsOptedOut = this.smsOptedOut.include==='true'?true:false
      const dataRequest = {
        action: 'checkCreateNewAccount',
        email: this.newAccountData.email,
        password: md5(this.newAccountData.password).toUpperCase(),
        firstName: this.newAccountData.firstName,
        lastName: this.newAccountData.lastName,
        dob: moment(this.newAccountData.dob).format('YYYY-MM-DD'),
        idDonationOrDonor: this.newAccountData.idDonationOrDonor,
        phoneMobile: xlooLib.phoneCleaner(this.newAccountData.phoneMobile),
        smsOptedOut: Number(this.newAccountData.smsOptedOut),
        findBy: this.findDonorBy.value,
        requiredArr: this.requiredArr,
      }

      this.$root.$emit("showSpinner");
      const resRequest = await this.$store.dispatch("auth/SET_checkNewAccount", dataRequest);
      this.$root.$emit("hideSpinner");

      switch (resRequest.result){
        case 'donor_found':
          this.$store.commit('auth/set_createNewAccountData', {email: this.newAccountData.email})
          this.$store.commit('auth/set_createNewAccountData', {password: md5(this.newAccountData.password).toUpperCase()})
          this.$store.commit('auth/set_createNewAccountData', {firstName: this.newAccountData.firstName})
          this.$store.commit('auth/set_createNewAccountData', {lastName: this.newAccountData.lastName})
          this.$store.commit('auth/set_createNewAccountData', {dob: this.newAccountData.dob})
          this.$store.commit('auth/set_createNewAccountData', {idDonationOrDonor: this.newAccountData.idDonationOrDonor})
          this.$store.commit('auth/set_createNewAccountData', {phoneMobile: this.newAccountData.phoneMobile})
          this.$store.commit('auth/set_createNewAccountData', {smsOptedOut: Number(this.newAccountData.smsOptedOut)})
          if(typeof resRequest.donorId !=='undefined'){
            this.$store.commit('auth/set_createNewAccountData', {idDonor: resRequest.donorId})
          }

          this.$store.commit('auth/set_showPage', { triggerRequestActivationCode: true})

          this.$router.push({ name:'cnaRequestActivationCode' })
          break
        case 'donor_exists':
          this.callDangerMessageBox('You are already registered, please login. If you forgot your password, please use the “Forgot Password” link to reset it.')
          this.$router.push({ name: 'loginDonor' })
          break
        case 'donorIdNotFound':
          this.callDangerMessageBox('Not found Donor Id.')
          break;
        case 'previousDonationsNotFound':
          this.callDangerMessageBox('Not found Previous Donation.')
          break;
        case 'donorIdOrPreviousDonationsNotFound':
          this.callDangerMessageBox('Not found Previous Donation or Donor ID.')
          break;
        case 'false_data':
          this.callDangerMessageBox(this.messageDonorNotFound)
          break
        case 'double_email':
          this.callDangerMessageBox(this.messUniqueEmailValidation)
          break
      }
    },
    changeDob(date){
      this.newAccountData.dob = moment(date).format("MM/DD/YYYY");
      this.objInvalid.dob = false;
    },
    optedOutFocusIn(){
      this.objInvalid.smsOptedOut = false;
    },
    passwordFocusIn(){
      this.objInvalid.password = false;
    },
    passwordConfirmFocusIn(){
      this.objInvalid.passwordConfirm = false;
    },
    firstNameFocusIn(){
      this.objInvalid.firstName = false;
    },
    lastNameFocusIn(){
      this.objInvalid.lastName = false;
    },
    emailFocusIn(){
      this.objInvalid.email = false;
    },
    dobFocusIn(){
      this.objInvalid.dob = false;
    },
    mobilePhoneFocusIn(){
      this.objInvalid.homePhone = false;
    },
    idDonationOrDonorFocusIn(){
      this.objInvalid.donationOrDonor = false;
    },
    optedOutChange(){
      if(this.smsOptedOut.include ==="false"){
        this.seenSms = true;
      } else {
        this.seenSms = false;
      }
    },
    callDangerMessageBox(text){
      this.$root.$emit('messageBox',{
        timeShow: 0,
        typeColor: 'danger',
        textMessage: text,
      })
    }
  },
}
</script>

<style scoped>
  #DonationHelp{
    display: flex;
  }
  .p-section{
    color: inherit;
    font-size: 1rem;
  }
  .span-links{
    text-decoration: underline;
    position: relative;
  }
  .span-links:hover {
    text-decoration: none;
  }

  .links-section {
    color: var(--BasicFontColor);
    font-size: 1rem;
    text-decoration: none;
    font-weight: 600;
  }
  .links-section:hover {
    color: var(--ButtonColor);
    text-decoration: none;
  }
</style>
